const Header = () => {
  return (
    <div className="flex justify-center items-center bg-blue-500 py-2 px-6 text-sm">
      <div className="flex text-white text-2xl items-center gap-2">
        <span>Masakin App</span>
      </div>
     
    </div>
  );
};

export default Header;
